import * as reducers from './reducers';

export const constants = {
  NAME: 'share',
};

export default { constants, reducers };
